import React from "react";
import Label from "../Common/Label";
import "./ImageAndContentIns.css";

const LinkedInPostLandScape: React.FC = () => {
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <div className="header-label">
            <Label children="Best Practices" fontWeight={600} fontSize="20px" />
          </div>
          <div className="list-items mt-2">
            <ul className="custom-list">
              <li>
                <Label
                  children="Use high-resolution, professional images (1080p minimum) "
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Keep text in the “safe zone” (avoid edges to prevent cropping on mobile)"
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Write a compelling first sentence – only the first 3 lines show before “See More”"
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Include a CTA (Call-to-Action), e.g., “Apply via the link in comments”"
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Tag relevant people & companies to increase reach"
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="header-label">
            <Label children="Restrictions " fontWeight={600} fontSize="20px" />
          </div>
          <div className="list-items mt-2">
            <div>
              <Label
                children="Image Restrictions:"
                fontWeight={400}
                fontSize="14px"
              />
              <ul>
                <li>
                  <Label
                    children="Formats: JPG, PNG"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Aspect Ratio: 1.91:1 (Landscape)"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Max File Size: 5MB"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>
              </ul>
            </div>
            <div>
              <Label
                children="Text Restrictions:"
                fontWeight={400}
                fontSize="14px"
              />
              <ul>
                <li>
                  <Label
                    children="Caption Limit: 3,000 characters"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Hashtags: No official limit, but best practice: 3-5 hashtags"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Mentions: Allowed (@username, @company)"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Links: Not clickable in captions, but you can direct users to the link in comments"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkedInPostLandScape;
